var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "barcode-management" } },
      [
        _c(
          "v-row",
          { attrs: { "no-gutters": "" } },
          [
            _c("v-col", { attrs: { cols: "12" } }),
            _c("v-col", { attrs: { cols: "12", sm: "8" } }, [
              _c(
                "div",
                { staticClass: "d-flex align-center gap-2 mb-6" },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v(" mdi-barcode "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "title primary--text font-weight-medium" },
                    [_vm._v(" จัดการบาร์โค้ด ")]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "v-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "v-tabs",
                  {
                    attrs: {
                      height: "56",
                      "background-color": "transparent",
                      "show-arrows": "",
                    },
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _vm._l(_vm.tabItems, function (tabItem) {
                      return _c(
                        "v-tab",
                        {
                          key: tabItem.value,
                          attrs: { to: tabItem.to, ripple: false },
                        },
                        [_vm._v(" " + _vm._s(tabItem.value) + " ")]
                      )
                    }),
                    _c("v-tabs-slider", { attrs: { color: "primary" } }),
                  ],
                  2
                ),
                _c(
                  "v-card",
                  {
                    staticClass: "tab-router-view pa-10",
                    attrs: { elevation: "0", tile: "" },
                  },
                  [_c("router-view")],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }